// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_93444fe79c--switch--Iu4Bo","indicator":"_93444fe79c--indicator--JD6wH","disabled":"_93444fe79c--disabled--WS_Zh"};